/**
 * Text Selection Popup Component
 *
 * Displays a floating button when text is selected, allowing users to
 * add the selected text as context to a side panel for isolated questions.
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
type TextSelectionPopupProps = {
  x: number;
  y: number;
  onAddContext: () => void;
  isContextPanelOpen?: boolean;
};
const TextSelectionPopup: React.FC<TextSelectionPopupProps> = t0 => {
  const $ = _c(13);
  const {
    x,
    y,
    onAddContext,
    isContextPanelOpen: t1
  } = t0;
  const isContextPanelOpen = t1 === undefined ? false : t1;
  const t2 = `${x}px`;
  const t3 = `${y}px`;
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = {
      left: t2,
      top: t3,
      transform: "translate(-50%, -100%)"
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = `flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium text-white shadow-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-slate-950 transition-all ${isContextPanelOpen ? "bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500" : "bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500"}`;
  let t6;
  if ($[3] !== isContextPanelOpen) {
    t6 = <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">{isContextPanelOpen ? <><path d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" /></> : <><path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" /><path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" /></>}</svg>;
    $[3] = isContextPanelOpen;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = isContextPanelOpen ? "Ask a Question About This As Well?" : "Ask a Question About This?";
  let t8;
  if ($[5] !== onAddContext || $[6] !== t5 || $[7] !== t6 || $[8] !== t7) {
    t8 = <button onClick={onAddContext} className={t5}>{t6}{t7}</button>;
    $[5] = onAddContext;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4 || $[11] !== t8) {
    t9 = <div className="fixed z-50 animate-in fade-in zoom-in duration-150" style={t4}>{t8}</div>;
    $[10] = t4;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};
export default TextSelectionPopup;